import { useEffect, useState } from 'react';
import { getPatterns } from '../common/callAPIs';
import { isArray } from 'lodash';
import { replaceS3WithCF } from '../common/replaceS3WithCF';

export function useLoadPatterns(queryInfo, productInfo) {
  const [patternList, setPatternList] = useState([]);

  useEffect(() => {
    loadPatterns();
  }, []);

  const loadPatterns = async () => {
    getPatterns(queryInfo, productInfo)
      .then((res) => res.json())
      .then((data) => {
        if (!isArray(data)) throw new Error('Something went wrong');

        const patterns = data?.map((item) => ({
          Id: item?.element_id,
          Thumbnail: replaceS3WithCF(item?.thumbnail),
          Scale: item?.scale,
          Rotate: item?.rotate,
          ThumbnailImg: replaceS3WithCF(item?.thumbnail_img || item?.thumbnail),
          IsPattern: item?.type_element === 1,
        }));

        setPatternList(patterns);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  return { patternList };
}
